import React, { useEffect, useCallback, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import { TranslatorContext } from '@jutro/locale';
import styles from './ContactComponent.module.scss';
import metadata from './ContactComponent.metadata.json5';
import AddressLookupComponent from '../AddressLookup/AddressLookupComponent';
import AddressComponent from "../../../nexus-capability-gateway-react/Components/Address/AddressComponent";
import  messages from '../AdditionalInsuredInterest/AdditionalInsuredInterestComponent.messages';


function ContactComponent(props) {
    const {contactVM, onValueChange} = props;
    const [isPageInitialized, setIsPageInitialized] = useState(false);
    const [selectedPhoneType, updateSelectedPhoneType] = useState({
        homeRadioButton: '',
        workRadioButton: '',
        mobileRadioButton: ''
    });
    const writeValue = (value, path) => {
        const phoneTypes = ['homeRadioButton', 'workRadioButton', 'mobileRadioButton'];
        _.set(contactVM, 'homeRadioButton', '');
        _.set(contactVM, 'workRadioButton', '');
        _.set(contactVM, 'mobileRadioButton', '');
        if (phoneTypes.includes(path)) {
            _.set(contactVM, path, value);
            _.set(contactVM, 'primaryPhoneType.value', value);
            //_.set(contactVM, 'accountHolder.value.primaryPhoneType', value);
            updateSelectedPhoneType({
                homeRadioButton: path === 'homeRadioButton' ? value : '',
                workRadioButton: path === 'workRadioButton' ? value : '',
                mobileRadioButton: path === 'mobileRadioButton' ? value : ''
            });
        }
        const hasPrimaryPhone = _.filter(selectedPhoneType, (p)=> {
            return !_.isEmpty(p)
        }).length != 0
        _.set(contactVM, 'isPhoneNonMandatory', hasPrimaryPhone);
        onValueChange(value, path);
    };
    const translator = useContext(TranslatorContext);
    const onAddressChange = (value, path) => {
        writeValue(value, `primaryAddress.${path}`);
    };

    const overrideProps = {
        '@field': {
            labelPosition: 'left',
            onValueChange: writeValue,
            showRequired: true
        },
        companyContainer: {
            visible: _.get(contactVM, 'subtype.value') === 'Company'
        },
        personalContainer: {
            visible: _.get(contactVM, 'subtype.value') === 'Person' 
        },
        additionalInsuredCountry: {
            visible: !_.isEmpty(
                _.get(
                    contactVM,
                    'primaryAddress.country.aspects.availableValues'
                )
            )
        },
        additionalInsuredState: {
            visible: !_.isEmpty(
                _.get(
                    contactVM,
                    'primaryAddress.state.aspects.availableValues'
                )
            )
        },        
        contactAddressComponent:{
            model: contactVM.primaryAddress,
            onValueChange: onAddressChange,
            requiredFields: ['addressType']
        },
        homeRadioButtonId: {
            visible:
                !_.get(contactVM, 'subtype.value') === 'Company'
                || _.get(contactVM, 'subtype.value') === 'Person',
            value: selectedPhoneType.homeRadioButton ? 'home' : '',
            availableValues: [
                {
                    code: 'home',
                    name: translator(messages.primaryNumber)
                }
            ]
        },
        workRadioButtonId: {
            value: selectedPhoneType.workRadioButton ? 'work' : '',
            availableValues: [
                {
                    code: 'work',
                    name: translator(messages.primaryNumber)
                }
            ]
        },
        mobileRadioButtonId: {
            value: selectedPhoneType.mobileRadioButton ? 'mobile' : '',
            availableValues: [
                {
                    code: 'mobile',
                    name: translator(messages.primaryNumber)
                }
            ]
        },
        homePhone: {
            required: (selectedPhoneType.homeRadioButton == 'home') ? true : false,
            showRequired: (selectedPhoneType.homeRadioButton == 'home')  ? true : false
        },
        workPhone: {
            required: (selectedPhoneType.workRadioButton == 'work')  ? true : false,
            showRequired: (selectedPhoneType.workRadioButton == 'work')  ? true : false
        },
        mobilePhone: {
            required: (selectedPhoneType.mobileRadioButton == 'mobile')  ? true : false,
            showRequired: (selectedPhoneType.mobileRadioButton == 'mobile')  ? true : false
        }
    };

    const initializeRadioButton = () => {
        const primaryPhone = _.get(contactVM, 'primaryPhoneType.value.code');
        let selectedPhone = '';
        if (contactVM.value.isPhoneNonMandatory) {
            if (primaryPhone && primaryPhone === 'home') {
                (contactVM.homeNumber.value == 'null') ? (contactVM.primaryPhoneType.value ='null') : (selectedPhone = primaryPhone || 'home');
            } else if (primaryPhone && primaryPhone === 'work') {
                 (contactVM.workNumber.value == 'null') ? (contactVM.primaryPhoneType.value ='null') : (selectedPhone = primaryPhone || 'work');
            } else if (primaryPhone && primaryPhone === 'mobile') {
                (contactVM.cellNumber.value == 'null') ? (contactVM.primaryPhoneType.value ='null') : (selectedPhone = primaryPhone || 'mobile');
            }

        } else {
             selectedPhone = primaryPhone || 'home';
            if (_.get(contactVM, 'subtype.value') === 'Company') {
                selectedPhone = primaryPhone || 'work';
            }

            if (!contactVM.primaryPhoneType.value) {
                onValueChange(selectedPhone, 'primaryPhoneType.value');
            }
        }

        updateSelectedPhoneType({
            workRadioButton: selectedPhone === 'work' ? selectedPhone : '',
            homeRadioButton: selectedPhone === 'home' ? selectedPhone : '',
            mobileRadioButton: selectedPhone === 'mobile' ? selectedPhone : '',
        });

    };



    useEffect(() => {
        if(!isPageInitialized){
            initializeRadioButton();
            setIsPageInitialized(true);
        }
    }, [initializeRadioButton, contactVM]);
    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
        },
        resolveComponentMap: {
            /*addressLookupComponent: AddressLookupComponent,*/
            addressComponent: AddressComponent
        },
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={contactVM}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
        />
    );
}

export default ContactComponent;
